import constants from "../config/constants";
import { makeRequest } from "./request";
import { getUserData, getUserId } from "./persist";
import { logPageView, logEvent } from "../utils/appInsight";
import * as Adobe from "./adobeAnalytics";

export default {
  async logFlashcardFlip({ contentKey, contentSubKey }) {
    let data = {
      userId: getUserId(),
      logType: constants.logTypes.flashcardFlip,
      contentType: constants.contentTypes.contentItem,
      contentSubType: constants.contentSubTypes.flashcards,
      contentKey: contentKey,
      contentSubKey: contentSubKey,
    };
    logEvent(constants.logTypes.flashcardFlip, data);
    await makeRequest("post", "/api/log", data);
  },
  async logFlashcardsReset(contentKey) {
    let data = {
      userId: getUserId(),
      logType: constants.logTypes.flashcardsReset,
      contentType: constants.contentTypes.contentItem,
      contentSubType: constants.contentSubTypes.flashcards,
      contentKey: contentKey,
    };
    logEvent(constants.logTypes.flashcardsReset, data);
    await makeRequest("post", "/api/log", data);
  },
  async logQuizResult({ contentKey, results }) {
    let data = {
      userId: getUserId(),
      logType: constants.logTypes.quizResult,
      contentType: constants.contentTypes.contentItem,
      contentSubType: constants.contentSubTypes.quiz,
      contentKey: contentKey,
      data: JSON.stringify(results),
    };
    logEvent(constants.logTypes.quizResult, data);
    await makeRequest("post", "/api/log", data);
  },
  async logExamResult({ contentKey, results }) {
    let data = {
      userId: getUserId(),
      logType: constants.logTypes.examResult,
      contentType: constants.contentTypes.contentItem,
      contentSubType: constants.contentSubTypes.exam,
      contentKey: contentKey,
      data: JSON.stringify(results),
    };
    logEvent(constants.logTypes.examResult, data);
    await makeRequest("post", "/api/log", data);
  },
  async logFeedbackSent(feedback) {
    let data = {
      userId: getUserId(),
      logType: constants.logTypes.feedbackSent,
      contentType: constants.contentTypes.feedback,
      contentSubType: constants.contentSubTypes.feedbackForm,
      contentKey: constants.contentKeys.notFoundForm,
      data: JSON.stringify(feedback),
    };
    logEvent(constants.logTypes.feedbackSent, data);
    await makeRequest("post", "/api/log", data);
  },
  async logViewItem({ contentKey, contentSubType }) {
    let data = {
      userId: getUserId(),
      logType: constants.logTypes.viewItem,
      contentType: constants.contentTypes.contentItem,
      contentSubType: contentSubType,
      contentKey: contentKey,
    };
    logEvent(constants.logTypes.viewItem, data);
    await makeRequest("post", "/api/log", data);
  },
  async logShare({ contentKey, contentSubType }) {
    let data = {
      userId: getUserId(),
      logType: constants.logTypes.share,
      contentType: constants.contentTypes.contentItem,
      contentSubType: contentSubType,
      contentKey: contentKey,
    };
    logEvent(constants.logTypes.share, data);
    await makeRequest("post", "/api/log", data);
  },
  async logAudioClick(contentSubKey) {
    let data = {
      userId: getUserId(),
      logType: constants.logTypes.audioClick,
      contentType: constants.contentTypes.click,
      contentSubType: constants.contentSubTypes.audioClick,
      contentKey: constants.contentKeys.audio,
      contentSubKey: contentSubKey,
    };
    logEvent(constants.logTypes.audioClick, data);
    if(!window.location.pathname.includes("SharedPosts")){
    await makeRequest("post", "/api/log", data);}
  },
  async logDownloadClick({ contentSubKey, contentKey }) {
    let data = {
      userId: getUserId(),
      logType: constants.logTypes.downloadClick,
      contentType: constants.contentTypes.click,
      contentSubType: constants.contentSubTypes.downloadClick,
      contentKey,
      contentSubKey,
    };
    logEvent(constants.logTypes.downloadClick, data);
    await makeRequest("post", "/api/log", data);
  },
  async logPipelineClick(contentSubKey) {
    let data = {
      userId: getUserId(),
      logType: constants.logTypes.pipelineClick,
      contentType: constants.contentTypes.click,
      contentSubType: constants.contentSubTypes.pipelineClick,
      contentKey: constants.contentKeys.sidebar,
      contentSubKey: contentSubKey,
    };
    logEvent(constants.logTypes.pipelineClick, data);
    await makeRequest("post", "/api/log", data);
  },
  async logPipelineQuickreadsClick(contentSubKey) {
    let data = {
      userId: getUserId(),
      logType: constants.logTypes.pipelineClick,
      contentType: constants.contentTypes.click,
      contentSubType: constants.contentSubTypes.pipelineClick,
      contentKey: constants.contentKeys.quickreads,
      contentSubKey: contentSubKey,
    };
    logEvent(constants.logTypes.pipelineClick, data);
    await makeRequest("post", "/api/log", data);
  },
  async logFilterClick({ contentKey, contentSubKey }) {
    let data = {
      userId: getUserId(),
      logType: constants.logTypes.filter,
      contentType: constants.contentTypes.click,
      contentSubType: constants.contentSubTypes.filterClick,
      contentKey: contentKey,
      contentSubKey: contentSubKey,
    };
    logEvent(constants.logTypes.filter, data);
    await makeRequest("post", "/api/log", data);
  },
  async logPageVisit({ contentKey, contentSubType }) {
    let data = {
      userId: getUserId(),
      logType: constants.logTypes.pageVisit,
      contentType: constants.contentTypes.pageVisit,
      contentSubType: contentSubType,
      contentKey: contentKey,
    };
    logPageView({ name: contentKey });
    await makeRequest("post", "/api/log", data);
  },
  async logUserSignin() {
    let data = {
      userId: getUserId(),
      logType: constants.logTypes.login,
      contentKey: constants.pageKeys.login,
    };
    logPageView({ name: constants.pageKeys.login });
    await makeRequest("post", "/api/log", data);
  },
  async logUserSignout() {
    let data = {
      userId: getUserId(),
      logType: constants.logTypes.logout,
      contentKey: constants.pageKeys.logout,
    };
    logPageView({ name: constants.pageKeys.logout });
    await makeRequest("post", "/api/log", data);
  },
  async logViewedItemBlacklisted(context, { contentKey }) {
    let data = {
      userId: getUserId(),
      logType: constants.logTypes.viewedItemBlacklisted,
      contentType: constants.contentTypes.contentItem,
      contentSubType: constants.contentSubTypes.blacklist,
      contentKey,
    };
    logEvent(constants.logTypes.viewedItemBlacklisted, data);
    await makeRequest("post", "/api/log", data);
  },
  async logSubscription() {
    let data = {
      userId: getUserId(),
      logType: constants.logTypes.subscription,
      contentKey: constants.pageKeys.home,    
    };
    Adobe.trackSubscription();
    logEvent(constants.logTypes.subscription, data);
    await makeRequest("post", "/api/log", data);
  },
  async logPurchase() {
    let data = {
      userId: getUserId(),
      logType: constants.logTypes.purchase,
      contentKey: constants.pageKeys.home,    
    };
    Adobe.trackPurchase();
    logEvent(constants.logTypes.purchase, data);
    await makeRequest("post", "/api/log", data);
  },
  async logSpxPurchaseClick() {
    let data = {
      userId: getUserId(),
      logType: constants.logTypes.spxPurchaseClick,
      contentKey: constants.pageKeys.landingPage,    
    };
    Adobe.trackSpxPurchaseClick();
    logEvent(constants.logTypes.spxPurchaseClick, data);
    await makeRequest("post", "/api/log", data);
  },
};
